import { Component, Input, OnInit } from '@angular/core';
import { AuthServiceService } from '../../../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../environments/environment';
import { LocalServiceService } from '../../../shareModule/services/local-service.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-add-product-crousal',
  templateUrl: './add-product-crousal.component.html',
  styleUrls: ['./add-product-crousal.component.scss'],
})
export class AddProductCrousalComponent implements OnInit {
  @Input() height: string;

  get_all_product_banner_response: any;
  get_all_product_banner_length: any;
  imgUrl = environment.ImageUrl;
  adminId: any = 0;
  carouselOptions: any = {
    pagination: true,
  };

  // array = [
  //   { 'id': 1, 'image': '../../../../assets/images/add_product_banner_1.jpg' },
  //   { 'id': 2, 'image': '../../../../assets/images/add_product_banner_2.jpg' },
  //   { 'id': 3, 'image': '../../../../assets/images/add_product_banner_3.jpg' },
  //   { 'id': 4, 'image': '../../../../assets/images/add_product_banner_4.jpg' }
  // ];

  constructor(
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private local: LocalServiceService,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit(): void {
    const { id } = this.local.getUser();

    this.adminId = this.route.snapshot.queryParams.adminId ?? id;
    this.getAllSliderBanners();
  }

  getAllSliderBanners() {
    this.auth.get_all_product_banner(this.adminId).subscribe(
      (response: any) => {
        this.get_all_product_banner_response = response.body;
        this.get_all_product_banner_length = response.body.length;
      },
      (e) => {
        this.toastr.error(e.error.message);
      }
    );
  }
}
